var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"notices",attrs:{"name":"grow","tag":"ol"}},_vm._l((_vm.notices),function(notice){return _c('li',{key:notice.id,class:[notice.type, 'notice'],domProps:{"innerHTML":_vm._s(notice.message)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }